/**
 * Vue i18n loader
 * created by @musnow
 * https://github.com/musnow
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
// default language
//业务语言包
import enUS from './lang/en-US'
import zhCn from './lang/zh-CN'
import koKR from './lang/ko-KR'
// VXETable组件的语言包(改成异步获取的方式更好)
import tableEN from 'vxe-table/lib/locale/lang/en-US'
import tableZHCN from 'vxe-table/lib/locale/lang/zh-CN'
// import tableKR from 'vxe-table/lib/locale/lang/'
//ant-design-vue组件语言包
import ant_zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import ant_enUS from 'ant-design-vue/lib/locale-provider/en_US'
import ant_koKR from 'ant-design-vue/lib/locale-provider/ko_KR'
// change default accept-language
import { axios } from '@/utils/request'
import store from '../store'
import { LANG } from '@/store/mutation-types'


Vue.use(VueI18n)

export const defaultLang = store.getters.lang ? store.getters.lang : 'zh-CN'

const messages = {
  'en-US': {
    ...enUS,
    ...tableEN
  },
  'zh-CN': {
    ...tableZHCN,
    ...zhCn
  },
  'ko-KR': {
    ...koKR,
    ...tableEN
  }
}

export function setAntLangs() {
  const antLangs = new Map()
  antLangs.set('en-US', ant_enUS)
  antLangs.set('zh-CN', ant_zhCN)
  antLangs.set('ko-KR', ant_koKR)
  //console.log('antLangs',antLangs)
  return antLangs
}

export function getAntLangs(lang) {
  const langReset = Vue.ls.get(LANG)
  if (lang !== langReset) {
    store.dispatch('SetLang', langReset)
    return setAntLangs().get(langReset)
  }
  return setAntLangs().get(lang)
}

const i18n = new VueI18n({
  locale: defaultLang,
  fallbackLocale: defaultLang,
  silentTranslationWarn: true,
  messages
})

export default i18n

const loadedLanguages = [defaultLang]

// 从缓存設置中加载当前语言
// if (Vue.ls.get('lang') !== null && defaultLang !== Vue.ls.get('lang')) {
//   loadLanguageAsync(localStorage.lang)
// }

function setI18nLanguage(lang) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function loadLanguageAsync(lang = defaultLang) {
  return new Promise(resolve => {
    // 缓存语言设置
    if (i18n.locale !== lang) {
      Vue.ls.set(LANG, lang)
      if (!loadedLanguages.includes(lang)) {
        return import(/* webpackChunkName: "lang-[request]" */ `./lang/${lang}`).then(msg => {
          i18n.setLocaleMessage(lang, msg.default)
          loadedLanguages.push(lang)
          return setI18nLanguage(lang)
        })
      }
      return resolve(setI18nLanguage(lang))
    }
    return resolve(lang)
  })
}
